import { render } from "./gallery.vue?vue&type=template&id=601ce552&scoped=true&ts=true"
import script from "./gallery.vue?vue&type=script&lang=ts"
export * from "./gallery.vue?vue&type=script&lang=ts"

import "./gallery.vue?vue&type=style&index=0&id=601ce552&scoped=true&lang=css"

import exportComponent from "/Volumes/jstChillin/Dropbox/pdc2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-601ce552"]])

export default __exports__